// extracted by mini-css-extract-plugin
export default {"resetLineHeight":"ContactPrivacyOptions-resetLineHeight_D7Tz8"};